// extracted by mini-css-extract-plugin
export var aniSpin = "l_d";
export var item = "l_q";
export var thumbs = "l_p";